export default {
  nav: {
    dashboard: "Panel de Control",
    analytics: "Dashboard",
    catalog: "Catálogo",
    changes: "Eventos",
    history: "Histórico",
    trends: "Tendencia de precios",
    prices: "Comparador Precios",
    alerts: "Avisos por correo",
    intelligence: "Inteligencia",
    radar: "Radar Regulatorio",
    calendar: "Calendario",
    reports: "Informes",
    configuration: "Configuración",
    products: "Mis Productos",
    competitors: "Competidores",
    sources: "Fuentes",
    severity: "Severidad",
    administration: "Administración",
    users: "Usuarios",
    auditLog: "Actividad",
    profile: "Mi perfil",
    notifications: "Avisos",
    tagline: "Monitorización inteligente del mercado farmacéutico",
    goToDashboard: "Ir al Dashboard",
    closeMenu: "Cerrar menú",
    availableInPlan: "Disponible en plan {plan}",
    versionHistory: "Ver historial de versiones",
  },
};
